import React, { useEffect, useState, lazy, memo } from 'react';
import { Check, X, FileText, Package, Mail, Rocket, Star, Clock, AlertTriangle } from 'lucide-react';
import { Section, CTAButton } from './Shared';
const LaunchUrgency = () => {
  const [timeLeft, setTimeLeft] = useState({
    h: 23,
    m: 58,
    s: 9
  });
  const [spotsTaken, setSpotsTaken] = useState(() => {
    const saved = typeof window !== 'undefined' ? sessionStorage.getItem('reflexo-launch-spots') : null;
    if (saved) {
      const {
        value,
        timestamp
      } = JSON.parse(saved);
      const elapsed = (Date.now() - timestamp) / 1000;
      const increment = Math.floor(elapsed / 60);
      return Math.min(value + increment, 92);
    }
    return 68;
  });
  useEffect(() => {
    sessionStorage.setItem('reflexo-launch-spots', JSON.stringify({
      value: spotsTaken,
      timestamp: Date.now()
    }));
  }, [spotsTaken]);
  useEffect(() => {
    const id = setInterval(() => {
      setTimeLeft(prev => {
        let {
          h,
          m,
          s
        } = prev;
        if (s > 0) s--;else {
          s = 59;
          if (m > 0) m--;else {
            m = 59;
            if (h > 0) h--;
          }
        }
        return {
          h,
          m,
          s
        };
      });
    }, 1000);
    return () => clearInterval(id);
  }, []);
  useEffect(() => {
    const id = setInterval(() => {
      setSpotsTaken(prev => {
        if (prev >= 92) return prev;
        return Math.random() < 0.4 ? prev + 1 : prev;
      });
    }, 45000 + Math.random() * 30000);
    return () => clearInterval(id);
  }, []);
  const fmt = (n: number) => n.toString().padStart(2, '0');
  const TimeBox = ({
    value,
    label
  }: {
    value: number;
    label: string;
  }) => <div className="flex flex-col items-center" data-id="element-215">
      <div className="bg-brand-rose text-white font-mono font-bold text-2xl md:text-4xl rounded-xl px-3 md:px-5 py-2 md:py-3 min-w-[56px] md:min-w-[80px] text-center shadow-md tabular-nums" data-id="element-216">
        {fmt(value)}
      </div>
      <span className="text-[10px] md:text-xs font-medium text-brand-text/70 mt-1.5 uppercase tracking-wider" data-id="element-217">
        {label}
      </span>
    </div>;
  return <div className="max-w-4xl mx-auto mb-12" data-id="element-218">
      <div className="glass-panel rounded-3xl p-6 md:p-8 border-2 border-brand-rose/40 bg-gradient-to-br from-white/90 to-brand-rose/5 shadow-[0_10px_40px_rgba(212,115,140,0.15)]" data-id="element-219">
        {/* Header */}
        <div className="flex items-center justify-center gap-2 mb-5" data-id="element-220">
          <Clock className="w-5 h-5 md:w-6 md:h-6 text-brand-rose shrink-0" data-id="element-221" />
          <h3 className="font-serif font-bold text-base md:text-xl text-brand-text text-center" data-id="element-222">
            PRECIO DE LANZAMIENTO — CIERRA EN:
          </h3>
        </div>

        {/* Countdown */}
        <div className="flex items-center justify-center gap-2 md:gap-4 mb-5" data-id="element-223">
          <TimeBox value={timeLeft.h} label="Horas" data-id="element-224" />
          <span className="text-2xl md:text-4xl font-bold text-brand-rose/60 pb-5" data-id="element-225">
            :
          </span>
          <TimeBox value={timeLeft.m} label="Min" data-id="element-226" />
          <span className="text-2xl md:text-4xl font-bold text-brand-rose/60 pb-5" data-id="element-227">
            :
          </span>
          <TimeBox value={timeLeft.s} label="Seg" data-id="element-228" />
        </div>

        {/* Warning */}
        <div className="flex items-center justify-center gap-2 bg-yellow-50 border border-yellow-300/60 rounded-xl px-4 py-3 mb-6" data-id="element-229">
          <AlertTriangle className="w-4 h-4 md:w-5 md:h-5 text-yellow-600 shrink-0" data-id="element-230" />
          <p className="text-sm md:text-base font-semibold text-yellow-900 text-center" data-id="element-231">
            Después sube $10.000 ARS.{' '}
            <span className="text-brand-rose" data-id="element-232">No vuelve.</span>
          </p>
        </div>

        {/* Spots */}
        <div className="bg-white/70 rounded-2xl p-4 md:p-5 border border-brand-pink/30" data-id="element-233">
          <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-1 mb-3" data-id="element-234">
            <div className="flex items-center gap-2" data-id="element-235">
              <span className="relative flex h-2.5 w-2.5" data-id="element-236">
                <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-red-500 opacity-75" data-id="element-237"></span>
                <span className="relative inline-flex rounded-full h-2.5 w-2.5 bg-red-500" data-id="element-238"></span>
              </span>
              <span className="font-semibold text-sm md:text-base text-brand-text" data-id="element-239">
                Cupos al precio de lanzamiento
              </span>
            </div>
            <span className="text-xs md:text-sm font-bold text-brand-rose uppercase tracking-wide" data-id="element-240">
              Quedan pocos
            </span>
          </div>

          <div className="w-full bg-brand-pink/15 rounded-full h-2.5 overflow-hidden mb-2" data-id="element-241">
            <div className="bg-gradient-to-r from-brand-rose to-red-500 h-2.5 rounded-full transition-all duration-1000 ease-out" style={{
            width: `${spotsTaken}%`
          }} data-id="element-242" />
          </div>

          <p className="text-xs md:text-sm text-brand-text/70 text-center" data-id="element-243">
            <strong className="text-brand-rose" data-id="element-244">{spotsTaken}%</strong> de los
            cupos al precio de lanzamiento ya tomados
          </p>
        </div>
      </div>
    </div>;
};
const REFLEXO_HREF = 'https://www.lumenakasha.com/cart/46722804678845:1';
const ACELERADOR_HREF = 'https://www.lumenakasha.com/cart/46787506733245:1';
const bonuses = [{
  icon: FileText,
  cover: 'https://cdn.magicpatterns.com/uploads/kTVMGQmsBM6vJpYSWhMgB9/legajo_de_campo.png',
  coverAlt: 'Tapa del Bonus 1 — El Legajo de Campo',
  title: 'BONUS 1 — EL LEGAJO DE CAMPO',
  pages: '30 páginas · listo para imprimir',
  desc: 'Ficha de ingreso, registro de sesiones, evolución, zonas trabajadas y alta terapéutica. Nunca más le preguntás a un paciente cómo se sentía la vez anterior.',
  result: '✅ Tu legajo clínico completo desde el primer día',
  price: '$12.000'
}, {
  icon: Package,
  cover: 'https://cdn.magicpatterns.com/uploads/v7i66s6myg8Padx72NCwD1/control_de_stock.png',
  coverAlt: 'Tapa del Bonus 2 — El Control de Abastecimiento',
  title: 'BONUS 2 — EL CONTROL DE ABASTECIMIENTO',
  pages: '30 páginas · listo para imprimir',
  desc: 'Auditoría, lista de insumos, control semanal, proveedores y gastos. Tu gabinete siempre listo antes de que empiece la jornada.',
  result: '✅ Nunca más te falta nada en plena jornada',
  price: '$10.000'
}, {
  icon: Mail,
  cover: 'https://cdn.magicpatterns.com/uploads/rFML4SsZbJhLMXdsU4xAF8/tarjeta_post.png',
  coverAlt: 'Tapa del Bonus 3 — Pack de Tarjetas Post-Sesión',
  title: 'BONUS 3 — PACK DE TARJETAS POST-SESIÓN',
  pages: '30 páginas · listo para imprimir',
  desc: 'Tarjetas profesionales para entregar a tus pacientes al finalizar cada sesión. Indicaciones claras, seguimiento concreto y una imagen de alto nivel que el paciente recuerda y valora.',
  result: '✅ Cerrá cada sesión con más profesionalismo y cuidado',
  price: '$8.000'
}];
// Comparison rows for the featured plan's "Sin / Con" table
const planComparison = [{
  situation: 'Paciente que vuelve después de 2 semanas',
  without: 'Le preguntás cómo se sentía',
  with: 'Abrís su ficha y retomás exacto'
}, {
  situation: 'Dirección/auditoría pide tu registro clínico',
  without: 'Improvisás papeles sueltos',
  with: 'Legajo profesional firmado'
}, {
  situation: 'Insumos en plena jornada',
  without: 'Te das cuenta cuando faltan',
  with: 'Control semanal anticipado'
}, {
  situation: 'Mostrarle al paciente su progreso',
  without: 'Lo decís de memoria',
  with: 'Evolución documentada visible'
}, {
  situation: 'Cierre de sesión',
  without: 'Se va sin pauta clara',
  with: 'Tarjeta post-sesión en mano'
}];
const plan1Items = [{
  name: 'Tomo Principal REFLEXO-PRO',
  value: '$40.000 ARS'
}, {
  name: 'Bonus 1: El Legajo de Campo',
  value: '$12.000 ARS'
}, {
  name: 'Bonus 2: El Control de Abastecimiento',
  value: '$10.000 ARS'
}, {
  name: 'Bonus 3: Pack de Tarjetas Post-Sesión',
  value: '$8.000 ARS'
}];
const plan2Items = [...plan1Items, {
  name: 'Acelerador de Consultorio',
  value: '$15.000 ARS'
}];
const aceleradorFeatures = ['Paquetes de 4, 8 y 12 sesiones que el paciente quiere comprar', 'Protocolo de Cierre en Camilla: el próximo turno reservado antes de que se vaya', 'Guiones de WhatsApp listos: recuperá pacientes y vendé sin incomodidad', 'Cómo subir precios sin perder pacientes', 'Instagram que atrae pacientes de calidad', 'Alianzas con otros profesionales de salud', 'Calculadora de rentabilidad incluida'];
const ValueTable = ({
  items,
  total,
  price
}: {
  items: {
    name: string;
    value: string;
  }[];
  total: string;
  price: string;
}) => <div className="rounded-2xl overflow-hidden border border-brand-pink/30 bg-white/70 mb-6" data-id="element-245">
    <div className="p-4 md:p-5 space-y-3" data-id="element-246">
      {items.map((item, i) => <div key={i} className="flex justify-between items-center gap-4 border-b border-brand-pink/15 pb-3 last:border-0 last:pb-0" data-id="element-247">
          <span className="text-brand-text/90 font-medium text-xs md:text-sm" data-id="element-248">
            {item.name}
          </span>
          <span className="text-brand-text/60 line-through text-xs md:text-sm whitespace-nowrap" data-id="element-249">
            {item.value}
          </span>
        </div>)}
    </div>
    <div className="bg-brand-surfaceLight/50 p-4 md:p-5 border-t border-brand-pink/30 space-y-2" data-id="element-250">
      <div className="flex justify-between items-center gap-4" data-id="element-251">
        <span className="font-serif font-bold text-sm md:text-base text-brand-text" data-id="element-252">
          Valor total
        </span>
        <span className="font-serif font-bold text-sm md:text-base text-brand-text/60 line-through whitespace-nowrap" data-id="element-253">
          {total}
        </span>
      </div>
      <div className="flex justify-between items-center gap-4" data-id="element-254">
        <span className="font-serif font-bold text-base md:text-lg text-brand-rose" data-id="element-255">
          Tu inversión hoy
        </span>
        <span className="font-serif font-bold text-xl md:text-2xl text-brand-rose whitespace-nowrap" data-id="element-256">
          {price}
        </span>
      </div>
    </div>
  </div>;
export const MethodOverview = () => {
  return <Section id="method" data-id="element-257">
      <div className="text-center mb-12" data-id="element-258">
        <div className="inline-flex items-center space-x-2 bg-white border border-brand-rose/30 px-4 py-1.5 rounded-full mb-6 shadow-sm" data-id="element-259">
          <span className="text-xl" data-id="element-260">🏆</span>
          <span className="font-serif font-semibold tracking-wider text-brand-rose text-sm md:text-base" data-id="element-261">
            KIT REFLEXO-PRO™
          </span>
        </div>
      </div>

      {/* Shared content: Tomo + Bonuses preview */}
      <div className="max-w-4xl mx-auto mb-16" data-id="element-262">
        <div className="rounded-2xl p-6 md:p-8 border bg-[#FFF5F5] border-brand-pink/30 backdrop-blur-sm shadow-sm mb-6" data-id="element-263">
          <div className="flex flex-col md:flex-row md:items-start gap-5" data-id="element-264">
            <div className="shrink-0 mx-auto md:mx-0" data-id="element-265">
              <img src="https://cdn.magicpatterns.com/uploads/uxbAGaCyuUFnkGMZK4VrzZ/portada_1.png" alt="Tapa del Tomo Principal REFLEXO-PRO" className="w-20 md:w-24 h-auto rounded-md shadow-md border border-brand-pink/20" loading="lazy" data-id="element-266" />
            </div>
            <div className="flex-grow" data-id="element-267">
              <h4 className="font-serif font-bold mb-2 text-lg text-brand-rose" data-id="element-268">
                TOMO PRINCIPAL — REFLEXO-PRO
              </h4>
              <p className="text-brand-text/90 font-medium mb-2 text-base" data-id="element-269">
                Sistema de Gestión Clínica Profesional · 50 páginas
              </p>
              <p className="text-brand-text/80 text-sm mb-4" data-id="element-270">
                El manual completo para organizar, estructurar y profesionalizar
                tu trabajo como terapeuta en reflexología.
              </p>
              <div className="bg-white/50 p-3 rounded-lg border border-brand-pink/20 text-xs text-brand-text/70" data-id="element-271">
                ✅ 100% orientado al terapeuta argentino
              </div>
            </div>
          </div>
        </div>

        <div className="text-center mb-8" data-id="element-272">
          <h3 className="text-xl md:text-2xl font-serif font-bold" data-id="element-273">
            🎁 3 BONUS ESTRATÉGICOS
          </h3>
          <p className="text-xs md:text-sm uppercase tracking-wider text-brand-text/60 mt-1" data-id="element-274">
            SIEMPRE INCLUIDOS
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-6" data-id="element-275">
          {bonuses.map((bonus, i) => {
          const Icon = bonus.icon;
          const numberLabel = String(i + 1).padStart(2, '0');
          return <div key={i} className="glass-panel rounded-2xl p-5 border-brand-rose/30 relative overflow-hidden bg-white/80 flex flex-col" data-id="element-276">
                {/* Numbered badge */}
                <div className="absolute top-3 left-3 bg-brand-rose/10 border border-brand-rose/30 text-brand-rose text-[11px] font-mono font-bold px-2 py-0.5 rounded-md" data-id="element-277">
                  {numberLabel}
                </div>
                <div className="absolute top-0 right-0 bg-brand-rose text-white text-xs font-bold px-3 py-1 rounded-bl-lg" data-id="element-278">
                  GRATIS
                </div>
                {bonus.cover ? <div className="mt-6 mb-4" data-id="element-279">
                    <img src={bonus.cover} alt={bonus.coverAlt || bonus.title} className="w-16 md:w-20 h-auto rounded-md shadow-md border border-brand-pink/20" loading="lazy" data-id="element-280" />
                  </div> : <Icon className="w-7 h-7 text-brand-rose mb-3 mt-6" data-id="element-281" />}
                <h4 className="text-base md:text-lg font-serif font-bold mb-2 pr-14 leading-tight" data-id="element-282">
                  {bonus.title}
                </h4>
                <p className="text-brand-rose/90 text-xs font-medium mb-3" data-id="element-283">
                  {bonus.pages}
                </p>
                <p className="text-brand-text/80 mb-3 text-xs md:text-sm flex-grow" data-id="element-284">
                  {bonus.desc}
                </p>
                <div className="text-xs font-medium text-brand-green mb-2" data-id="element-285">
                  {bonus.result}
                </div>
                <div className="text-xs text-brand-text/50 mt-auto" data-id="element-286">
                  <span className="line-through" data-id="element-287">{bonus.price}</span>
                  <span className="ml-2 font-bold text-brand-rose" data-id="element-288">
                    → GRATIS
                  </span>
                </div>
              </div>;
        })}
        </div>

        {/* Bonus total tagline */}
        <div className="text-center mt-8" data-id="element-289">
          <div className="inline-block glass-panel px-6 py-3 rounded-full border-brand-rose/30 bg-white/70" data-id="element-290">
            <p className="text-sm md:text-base font-medium text-brand-text/80" data-id="element-291">
              Valor total bonus{' '}
              <span className="line-through text-brand-text/50" data-id="element-292">$30.000</span>{' '}
              <span className="text-brand-rose font-bold" data-id="element-293">
                → GRATIS con tu Kit
              </span>
            </p>
          </div>
        </div>
      </div>

      {/* Launch urgency banner */}
      <LaunchUrgency data-id="element-294" />

      {/* Choose your kit heading */}
      <div id="pricing" className="text-center mb-10 max-w-3xl mx-auto scroll-mt-24" data-id="element-295">
        <h2 className="text-3xl md:text-5xl font-serif font-bold mb-3 text-brand-text" data-id="element-296">
          ELEGÍ TU KIT
        </h2>
        <p className="text-sm md:text-base text-brand-rose font-medium" data-id="element-297">
          ⏰ El precio de lanzamiento cierra pronto. Después sube $10.000.
        </p>
      </div>

      {/* The two plans */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 md:gap-8 max-w-6xl mx-auto" data-id="element-298">
        {/* Plan 1 */}

        {/* Plan 2 — featured */}
      </div>
    </Section>;
};